// For authentication and userInfo

import { apiRequest } from "api";
import * as crypto from "crypto-js";
import {AUTH_URL} from "constants/routes"
var decryptedTokenId = null;
export const getDecryptedResponse = response => {
  let decTokenId = null;
  const { token_id } = response;
  if (token_id) {
    decTokenId = crypto.AES.decrypt(
      token_id,
      "Q5mo=2WMXKAwmTkbwBlftGd6LVZjVKXh"
    ).toString(crypto.enc.Utf8);
      let responseJSON = response.result;
      responseJSON = JSON.parse(
        crypto.AES.decrypt(
          responseJSON,
          "Q5mo=2WMXKAwmTkbwBlftGd6LVZjVKXh"
        ).toString(crypto.enc.Utf8)
      );
      return responseJSON;
  } else {
    let responseJSON = response.result;
    responseJSON = JSON.parse(
      crypto.AES.decrypt(
        responseJSON,
        "Q5mo=2WMXKAwmTkbwBlftGd6LVZjVKXh"
      ).toString(crypto.enc.Utf8)
    );
    return responseJSON;
  }
};

// async function requestV1(
//   url = "",
//   options = { body: {} },
//   encrypt = true,
//   encryptedBodyReq = false
// ) {
//   if (encrypt) {
//     // console.log("inside if");
//     const reqUri = `${AUTH_URL}/api/auth/get-random-id`;
//     let option = {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "user-id": options?.headers?.["user-id"]
//       },
//     };
//     try {
//       const result = await apiRequest(reqUri, option);
//       const { status, tokenId } = result;
//       // console.log(status, tokenId);
//       if (status === "success") {
//         decryptedTokenId = crypto.AES.decrypt(
//           tokenId,
//           "Q5mo=2WMXKAwmTkbwBlftGd6LVZjVKXh"
//         ).toString(crypto.enc.Utf8);
//         const finalBody = JSON.stringify(options.body);
//         let encryptedBody = crypto.AES.encrypt(
//           finalBody,
//           decryptedTokenId
//         ).toString();
//         decryptedTokenId = btoa(decryptedTokenId);
//         let encryptedAPIParams = {
//           api_body: encryptedBody,
//           token_id: decryptedTokenId,
//         };
//         let _options = {...options};
//         _options.body = JSON.stringify(encryptedAPIParams);
//         if (encryptedBodyReq) {
//           return { ...encryptedAPIParams, ...{ decrypt: true } };
//         } else {
//           _options.body = JSON.stringify(encryptedAPIParams);
          
//           let resultV1 = await apiRequest(url, _options);
//           console.log("heere", resultV1)    

//           resultV1 = getDecryptedResponse(resultV1);
//           console.log("🚀 ~ resultV1:", resultV1)

//           return resultV1;
//         }
//       }else{
//         console.log("error", result)
//       }
//     } catch (error) {
//       console.log("Request error:", error);
//     }
//   } else if (!encrypt && encryptedBodyReq) {
//     let result = await apiRequest(url, options);
//     console.log("🚀 ~ result:", result)
//     result = getDecryptedResponse(result);
//     // console.log("inside elseif");
//     return result;
//   } else {
//     // console.log("inside else");
//     apiRequest(url,options).then(res=>{
//       // console.log(res)
//       return res
//     });
//     return apiRequest(url, options);
//   }
// }

// async function requestV1(
//   url = "",
//   options = { body: {} },
//   encrypt = true,
//   encryptedBodyReq = false
// ) {
//   if (encrypt) {
//     const reqUri = `${AUTH_URL}/api/auth/get-random-id`;
//     const option = {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "user-id": options?.headers?.["user-id"],
//       },
//     };

//     try {
//       const result = await apiRequest(reqUri, option);
//       const { status, tokenId } = result;

//       if (status === "success") {
//         let decryptedTokenId = crypto.AES.decrypt(
//           tokenId,
//           "Q5mo=2WMXKAwmTkbwBlftGd6LVZjVKXh"
//         ).toString(crypto.enc.Utf8);

//         const finalBody = JSON.stringify(options.body);
//         const encryptedBody = crypto.AES.encrypt(finalBody, decryptedTokenId).toString();
//         const base64Token = btoa(decryptedTokenId);

//         const encryptedAPIParams = {
//           api_body: encryptedBody,
//           token_id: base64Token,
//         };

//         if (encryptedBodyReq) {
//           return { ...encryptedAPIParams, decrypt: true };
//         }

//         const _options = {
//           ...options,
//           headers: {
//             ...options.headers,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(encryptedAPIParams),
//         };

//         let resultV1 = await apiRequest(url, _options);
//         resultV1 = getDecryptedResponse(resultV1);

//         return resultV1;
//       } else {
//         console.error("Failed to fetch tokenId:", result);
//         throw new Error("Unable to proceed without tokenId");
//       }
//     } catch (error) {
//       console.error("RequestV1 error:", error);
//       throw error;
//     }
//   } else if (!encrypt && encryptedBodyReq) {
//     let result = await apiRequest(url, options);
//     result = getDecryptedResponse(result);
//     return result;
//   } else {
//     return await apiRequest(url, options);
//   }
// }

async function requestV1(
  url = "",
  options = { body: {} },
  encrypt = true,
  encryptedBodyReq = false,
  tokenId
) {
  if (encrypt) {
    
    try {
      // console.log("option",option);
      
      // const result = await apiRequest(reqUri, option);
      // console.log("🚀 ~ requestV1 ~ result:", result)
      // const { status, tokenId } = result;
      // console.log(status, tokenId);
      // if (status === "success") {
      console.log("token ",tokenId);
      
        decryptedTokenId = crypto.AES.decrypt(
          tokenId,
          "Q5mo=2WMXKAwmTkbwBlftGd6LVZjVKXh"
        ).toString(crypto.enc.Utf8);
        const finalBody = JSON.stringify(options.body);
        let encryptedBody = crypto.AES.encrypt(
          finalBody,
          decryptedTokenId
        ).toString();
        
        decryptedTokenId = btoa(decryptedTokenId);
        let encryptedAPIParams = {
          api_body: encryptedBody,
          token_id: decryptedTokenId,
        };
        let _options = {...options};
        _options.body = JSON.stringify(encryptedAPIParams);
        if (encryptedBodyReq) {
          return { ...encryptedAPIParams, ...{ decrypt: true } };
        } else {
          _options.body = JSON.stringify(encryptedAPIParams);
          
          // console.log("🚀 ~ requestV1 ~ url:", url)
          // let resultV1 = await apiRequest(url, _options);
          // // console.log("heere", resultV1)    
          console.log("typeof encryptedBody", typeof encryptedBody);
          console.log("typeof decryptedTokenId", typeof decryptedTokenId);
          
          // resultV1 = getDecryptedResponse(resultV1);

          return _options.body;
        }
      // }
    } catch (error) {
      // console.log("Request error:", error);
    }
  } else if (!encrypt && encryptedBodyReq) {
    let result = await apiRequest(url, options);
    result = getDecryptedResponse(result);
    // console.log("inside elseif");
    return result;
  } else {
    // console.log("inside else");
    apiRequest(url,options).then(res=>{
      // console.log(res)
      return res
    });
    return apiRequest(url, options);
  }
}



export default requestV1;